<template>
  <div>
    <el-dialog
      title="同步员工"
      :visible.sync="showDialog"
      :close-on-click-modal="false"
      :before-close="cancelAction"
      append-to-body
      width="1240px"
    >
      <el-row>
        <el-col :span="6">
          <div class="grid-content bg-purple-dark">
            <div>
              <span class="title"> 企业 </span>
              <el-button
                type="text"
                @click="refreshDepartment"
              >
                更新同步
              </el-button>
            </div>

            <div>
              <!-- 部门搜索 -->
              <el-input
                v-model="searchDepartment"
                placeholder="请输入部门名称"
                class="input-m"
                prefix-icon="el-icon-search"
                style="margin-bottom: 15px"
                clearable
              />
              &nbsp;
              <el-button
                type="primary"
                @click="setCheckedNodes"
              >
                搜索
              </el-button>
            </div>
            <el-tree
              ref="tree"
              v-loading="treeLoading"
              class="department"
              :data="departmentTree"
              :props="defaultProps"
              :expand-on-click-node="false"
              node-key="id"
              default-expand-all
              highlight-current
              @node-click="handleNodeClick"
            />
          </div>
        </el-col>
        <el-col :span="18">
          <div class="grid-content bg-purple-dark">
            <div class="title">
              员工
            </div>
            <!-- 查询区 -->
            <ul class="search-btn">
              <li>
                <span class="m-r-6">工号</span>
                <el-input
                  v-model="params.work_userid"
                  placeholder="请输入工号"
                  class="input-m m-r-6"
                  prefix-icon="el-icon-search"
                  clearable
                />
              </li>
              <li>
                <span class="m-r-6">姓名</span>
                <el-input
                  v-model="params.username"
                  placeholder="请输入姓名"
                  class="input-m m-r-6"
                  prefix-icon="el-icon-search"
                  clearable
                />
              </li>
              <li>
                <el-button
                  type="primary"
                  @click="searchUser"
                >
                  搜索
                </el-button>
              </li>
            </ul>

            <el-table
              ref="multipleTable"
              v-loading="tableloading"
              :data="userList"
              tooltip-effect="dark"
              style="width: 100%"
              @selection-change="handleSelectionChange"
            >
              <el-table-column
                type="selection"
                width="55"
              />
              <el-table-column
                prop="work_userid"
                label="员工工号"
              />
              <el-table-column
                prop="user_name"
                label="员工姓名"
              />
              <el-table-column
                prop="store_name"
                label="操作"
                width="160px"
              >
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    @click="syncList('list', scope.row)"
                  >
                    同步
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <!-- <div>
              企微控件S-部门列表
              <qwContacts
                :type="'departmentName'"
                :openid="'id'"
                :datas="TreeData"
              />
              企微控件E-部门列表
            </div> -->
            <el-pagination
              class="content-padded"
              background
              :current-page="params.page"
              :page-size="params.page_size"
              layout="total, prev, pager, next, jumper"
              :total="total_count"
              @current-change="handleCurrentChange"
            />

            <div class="user-btns">
              <el-button
                type="primary"
                @click="syncList('all')"
              >
                同步当前部门
              </el-button>
              <el-button
                type="primary"
                @click="syncList('batch')"
              >
                批量同步
              </el-button>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-dialog>

    <!-- 选择成员类型角色 -->
    <SpChooseSalespersonType
      v-model="syncDialogVisible"
      employee-status
      @chooseType="chooseType"
    />
  </div>
</template>

<script>
import { getDepartment, getDepartmentUser, syncDepartment } from '@/api/component'
// import qwContacts from '@/components/qwContacts'
export default {
  name: 'SpRefreshStore',
  components: {
    // qwContacts
  },
  props: {
    refreshVisible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      TreeData: [],
      searchDepartment: '',
      userData: {},
      params: {
        page: 1,
        page_size: 6,
        department_id: 0,
        mobile: '',
        work_userid: '',
        username: ''
      },
      departmentTree: [],
      defaultProps: {
        children: 'subset',
        label: 'name'
      },
      total_count: 0,
      userList: [],
      tableloading: false,
      syncLoading: false, //同步加载
      syncDialogVisible: false, //选择员工类型弹窗
      syncParmas: {
        user_ids: '',
        department_ids: '',
        employee_status: 0,
        special_identity: '0'
      },
      multipleSelection: [],
      treeLoading: false
    }
  },
  computed: {
    showDialog () {
      return this.refreshVisible
    }
  },
  watch: {
    refreshVisible (newVal, oldVal) {
      if (newVal) {
        // this.getUser()
        this.total_count = 0
        this.userList = []
        this.params.page = 1
        this.params.page_size = 6
        this.getDepartmentData('getFirst')
      }
    }
  },
  methods: {
    // 关闭模态框
    cancelAction () {
      this.$emit('closeRefreshStoreDialog')
    },
    // 获取部门数据
    async getDepartmentData (type) {
      this.treeLoading = true
      this.searchDepartment = ''
      const datas = await getDepartment().catch(() => {
        this.treeLoading = false
      })
      // this.TreeData = JSON.parse(JSON.stringify(datas))
      if (datas) {
        if (datas.length < 1 && type === 'getFirst') {
          this.refreshDepartment('first')
        }
        this.departmentTree = datas

        //设置首次默认选中第一个
        let currentKey = datas[0].id
        this.$nextTick(() => {
          this.params.department_id = currentKey
          this.$refs.tree.setCurrentKey(currentKey)
          this.getUser()
        })

        this.treeLoading = false
      }
    },
    // 获取部门用户列表
    async getUser () {
      this.tableloading = true
      const data = await getDepartmentUser(this.params)
      if (data) {
        this.userList = data.list
        this.total_count = data.total_count
        this.tableloading = false
      }
    },

    handleNodeClick (data) {
      this.params.department_id = data.id
      this.getUser()
    },
    // 全选
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    // 员工列表分页
    handleCurrentChange (val) {
      this.params.page = val
      this.getUser()
    },
    // 搜索员工列表
    searchUser () {
      this.params.page = 1
      this.getUser()
    },
    // 同步列表
    async syncList (type, row) {
      this.syncParmas = {
        user_ids: '',
        department_ids: '',
        employee_status: 0,
        special_identity: '0'
      }
      if (type === 'list') {
        // 列表员工同步
        this.syncParmas.user_ids = row.work_userid

        // 判断是否已存在导购
        const data = await this.$api.component.isGuide(row.work_userid)
        if (data && data.salesperson_id) {
          // this.syncParmas.employee_status = data.employee_status
          // this.submitSync()
          this.$message.error('该成员已存在')
        } else {
          this.syncDialogVisible = true
        }
      } else if (type === 'all') {
        // 同步当前部门
        this.syncParmas.department_ids = this.params.department_id
        if (this.params.department_id) {
          this.syncDialogVisible = true
        } else {
          this.$message.error('请先选择需要同步的部门')
        }
      } else {
        // 批量同步
        if (this.multipleSelection.length > 0) {
          let userIds = []
          this.multipleSelection.forEach((v) => {
            userIds = userIds.concat(v.work_userid)
          })

          this.syncParmas.user_ids = userIds.join(',')
          this.syncDialogVisible = true
        } else {
          this.$message.error('请先勾选需要同步的员工')
        }
      }
    },

    // 确认同步
    async submitSync () {
      if (this.syncParmas.employee_status) {
        this.syncLoading = true
        const data = await syncDepartment(this.syncParmas).catch(() => {
          this.syncLoading = false
        })
        if (data) {
          this.syncLoading = false
          this.syncDialogVisible = false
          this.syncParmas.employee_status = 0

          this.$message({
            message: '同步成功',
            type: 'success'
          })
          this.$emit('submitRefreshStore')
        }
      } else {
        this.$message.error('请先选择员工类型')
      }
    },
    // 关闭选择同步成员类型弹窗
    closeSyncDialog () {
      this.syncDialogVisible = false
      this.syncParmas.employee_status = 0
    },

    // 部门搜索
    setCheckedNodes () {
      this.$refs.tree.filter(this.searchDepartment)
    },

    // 更新同步
    async refreshDepartment (type) {
      const data = await this.$api.component.refreshDepartment()
      if (data && type !== 'first') {
        this.$message({
          message: '更新同步成功',
          type: 'success'
        })
      }
    },

    // 选择同步类型
    chooseType (data) {
      this.syncParmas.employee_status = data.employee_status
      this.syncParmas.special_identity = data.special_identity
      this.syncDialogVisible = false
      this.submitSync()
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  margin-bottom: 15px;
  font-size: 18px;
}
.search-btn {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 20px;
  li {
    margin-right: 20px;
  }
}

.department {
  height: 620px;
  overflow: auto;
}

.user-btns {
  position: absolute;
  right: 0;
  bottom: 0;

  display: flex;
  justify-content: flex-end;
  margin-top: 15px;
}
</style>
